// @flow

import isAndroid from './isAndroid';
import isiOS from './isiOS';
import isBlackBerry from './isBlackBerry';
import isWindowsPhone from './isWindowsPhone';

export default function isMobile() {
   return isAndroid() || isiOS() || isBlackBerry() || isWindowsPhone();
}
